"use strict";

require("core-js/modules/es.object.assign.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthContext = void 0;
exports.AuthProvider = AuthProvider;
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.parse-int.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.search.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _auth0Js = _interopRequireDefault(require("auth0-js"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _jsBase = require("js-base64");
var _moment = _interopRequireDefault(require("moment"));
var _randomstring = _interopRequireDefault(require("randomstring"));
var _analytics = require("../utils/helpers/analytics");
var _errorLogger = require("../utils/helpers/errorLogger");
var _constants = require("../utils/constants");
var _jsxFileName = "/Users/anthony.hessler/Workspace/Interactive/web-tools-io/src/lib/context/AuthContext.js";
const _excluded = ["children"];
/* eslint-disable no-console */
/**
 * @module AuthContext
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Note: The contents of this file are leveraged from the source code for the
 * Life.Church Site v2 and v3 projects. Since this logic is now in a Context
 * and Provider, its structure and logical flow differs from original.
 *
 * @see For more information: {@link https://auth0.com/docs/libraries/auth0js#initialization}.
 */

/**
 * @typedef {object} User
 * @property {string} family_name - User family (last) name (e.g. 'Doe').
 * @property {string} given_name - User given (first) name (e.g. 'John').
 * @property {AppMetadata} app_metadata [https://www.life.church/app_metadata] - App metadata object.
 * @property {number} rock_person_alias_id [https://www.life.church/rock_person_alias_id] - Rock RMS person alias id (e.g. 8675309).
 * @property {UserMetadata} user_metadata [https://www.life.church/user_metadata] - User metadata object.
 * @property {string} name - User display name (e.g. 'John Doe').
 * @property {string} nickname - User nickname value (e.g. 'john.doe').
 * @property {string} picture - URL string of user picture (e.g. 'https://s.gravatar.com/avatar/abc123').
 * @property {string} sub - Authentication user id value (e.g. 'auth0|8jj67w5c3irt0j9j8j067wci').
 * @property {string} updated_at - Date/Time value of last updated (e.g. '2023-01-01T12:00:00.000Z').
 */

/**
 * @typedef {object} WebAuthConfig
 * @property {string} audience - The Auth0 audience (Example: 'https://product-apis.life.church').
 * @property {string} clientID - The Auth0 client ID (Example: 'AbcDeF1gh23i4JKLmNopQ5r6St7uvwX8').
 * @property {string} domain - The Auth0 account domain (Example: 'login-staging.life.church').
 * @property {string} redirectUri - The default redirectUri used. Defaults to an empty string (none).
 * @property {string} responseType - Optional default responseType used. It can be any space-separated list of the values `code`, `token`, `id_token`. Defaults to `token` unless a `redirectUri` is provided, when it defaults to `code`.
 * @property {string} scope - The default scope(s) used by the application, allowing return of specific claims for specific fields in the request.
 */

/**
 * @typedef {object} AuthContext
 * @property {Function} checkLogin - Convenience function to check for existing Login status for a user.
 * @property {Function} checkSession - Convenience function to check for existing session status for a user and enable silent authentication.
 * @property {Function} configure - Convenience function to configure and instantiate the Auth0.js webAuth object.
 * @property {Function} getAccessToken - Convenience function to check for and return authentication access token.
 * @property {Function} handleAuthentication - Handler function for authentication callback.
 * @property {boolean} isAuthenticated - Boolean flag denoting authentication status of the user.
 * @property {boolean} isConfigured - Boolean flag denoting configuration status of WebAuth.
 * @property {boolean} isError - Boolean flag denoting error status of authentication.
 * @property {boolean} isIdle - Boolean flag denoting idle status of authentication.
 * @property {boolean} isLoading - Boolean flag denoting loading status of authentication.
 * @property {boolean} isOrganization - Boolean flag denoting organization status of the user.
 * @property {boolean} isSuccess - Boolean flag denoting success status of authentication.
 * @property {boolean} isUserChecked - Boolean flag denoting checked status of a user.
 * @property {Function} logIn - Convenience function to trigger login process.
 * @property {Function} logOut - Convenience function to log out user.
 * @property {User} user - Authenticated user data object.
 */

const AuthContext = exports.AuthContext = /*#__PURE__*/_react.default.createContext({
  checkLogin: null,
  checkSession: null,
  configure: null,
  getAccessToken: null,
  handleAuthentication: null,
  isAuthenticated: false,
  isConfigured: false,
  isError: false,
  isIdle: true,
  isLoading: false,
  isOrganization: false,
  isSuccess: true,
  isUserChecked: false,
  logIn: null,
  logOut: null,
  user: null
});
AuthContext.displayName = 'AuthContext';

/**
 * React Context Provider for Life.Church authentication with Auth0.
 */
function AuthProvider(_ref) {
  let {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  // Convenience variables for Auth-related strings values.
  const authStrings = _constants.AUTH0;
  const {
    cookies: authCookies,
    errors: authErrors,
    localStorageKeys,
    profile: authProfile
  } = authStrings;

  // Set up state-based elements.
  const [isAuthenticated, setIsAuthenticated] = _react.default.useState(false);
  const [isConfigured, setIsConfigured] = _react.default.useState(false);
  const [isOrganization, setIsOrganization] = _react.default.useState(false);
  const [isUserChecked, setIsUserChecked] = _react.default.useState(false);
  const [status, setStatus] = _react.default.useState(_constants.STATUS_TYPES.IDLE);
  const [user, setUser] = _react.default.useState(null);

  // Convenience variables determined by set status type and returned for use.
  const isLoading = status === _constants.STATUS_TYPES.PENDING;
  const isIdle = status === _constants.STATUS_TYPES.IDLE;
  const isSuccess = status === _constants.STATUS_TYPES.RESOLVED;
  const isError = status === _constants.STATUS_TYPES.REJECTED;

  // Convenience state for initial login check.
  const [isInitialLoginChecked, setIsInitialLoginChecked] = _react.default.useState(false);
  const [webAuth, setWebAuth] = _react.default.useState(null);
  const [webAuthConfig, setWebAuthConfig] = _react.default.useState({
    audience: null,
    clientID: null,
    domain: null,
    redirectUri: null,
    responseType: 'token id_token',
    scope: 'openid profile'
  });

  /**
   * Convenience function to configure and instantiate the Auth0.js webAuth object.
   *
   * @param {object} params - The function params object.
   * @param {Function} [params.callback] - Optional callback function invoked after configuration is complete.
   * @param {WebAuthConfig} params.config - Object of required Auth0 config to instantiate the webAuth object. If not set, configuration will not occur.
   */
  const configure = _react.default.useCallback(function () {
    let {
      callback = () => {},
      config
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      callback: () => {},
      config: null
    };
    if (!config || isConfigured) {
      if (callback && typeof callback === 'function') {
        callback();
      }
      return;
    }
    const finalConfig = {
      audience: config.audience,
      clientID: config.clientID,
      domain: config.domain,
      redirectUri: config.redirectUri,
      responseType: config.responseType || 'token id_token',
      scope: config.scope || 'openid profile'
    };
    setWebAuthConfig(finalConfig);
    if (!webAuth) {
      setWebAuth(new _auth0Js.default.WebAuth(finalConfig));
      setIsConfigured(true);
    }
    if (callback && typeof callback === 'function') {
      callback();
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);

  /**
   * Convenience function to redirect to main Giving app.
   *
   * @param {object} params - The function params object.
   * @param {string} [params.error] - Optional error message to store for display of main app.
   * @param {string} [params.path] - Optional path to add to the redirect URL (Default: '').
   *
   * @returns {Function} Invocation of window.open() method.
   */
  const redirectToMainApp = _react.default.useCallback(function () {
    let {
      error,
      path = ''
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (error) {
      window.localStorage.setItem(localStorageKeys.errorAlert, error);
    } else {
      window.localStorage.removeItem(localStorageKeys.errorAlert);
    }
    return window.open("".concat(window.location.origin, "/").concat(path), '_self');
  }, [localStorageKeys]);

  /**
   * Convenience method to check whether the current time is past the Access
   * Token's expiry time and return a boolean value accordingly.
   *
   * @returns {boolean} Boolean flag denoting user authentication status.
   */
  const checkAuthenticationStatus = _react.default.useCallback(() => {
    const expiresAt = !Number.isNaN(Number(_jsCookie.default.get(authCookies.expiresAt)) * 1000) ? Number(_jsCookie.default.get(authCookies.expiresAt)) * 1000 : Number(window.localStorage.getItem(localStorageKeys.expiresAt)) * 1000;
    return Number(new Date().getTime()) < Number(expiresAt);
  }, [authCookies, localStorageKeys.expiresAt]);

  /**
   * Convenience function to check and return whether or not the supplied user
   * data object is attributed to a business profile or personal profile.
   *
   * @param {object} userProfileInfo - User profile data object.
   *
   * @returns {boolean} Boolean flag denoting whether user profile is business.
   */
  const checkOrganizationProfile = _react.default.useCallback(userProfileInfo => {
    return Boolean(userProfileInfo && userProfileInfo[authProfile.userMetadataUrl] ? userProfileInfo[authProfile.userMetadataUrl].organizationType : false);
  }, [authProfile]);

  /**
   * Convenience function to destroy the user session for log out request.
   */
  const destroyUserSession = _react.default.useCallback(() => {
    setIsAuthenticated(false);
    setIsOrganization(false);
    setIsUserChecked(false);
    setStatus(_constants.STATUS_TYPES.IDLE);
    setUser(null);
    window.localStorage.removeItem(localStorageKeys.accessToken);
    window.localStorage.removeItem(localStorageKeys.authorizeState);
    window.localStorage.removeItem(localStorageKeys.expiresAt);
    window.localStorage.removeItem(localStorageKeys.userProfile);
    window.localStorage.removeItem(localStorageKeys.userGivingData);
    _jsCookie.default.remove(authCookies.accessToken);
    _jsCookie.default.remove(authCookies.expiresAt);
  }, [authCookies, localStorageKeys]);

  /**
   * Convenience function to return stored value for authorization state.
   *
   * @returns {string} Stored encoded string value for authorization state.
   */
  const getEncodedString = _react.default.useCallback(() => {
    return window.localStorage.getItem(localStorageKeys.authorizeState);
  }, [localStorageKeys]);

  /**
   * Convenience function to set and store an encoded string used for auth.
   *
   * @returns {string} Local storage auth state value.
   */
  const setEncodedString = _react.default.useCallback(() => {
    try {
      const string = _jsBase.Base64.encode(_randomstring.default.generate());
      window.localStorage.setItem(localStorageKeys.authorizeState, string);
      _jsCookie.default.set(authCookies.authorizeState, string, {
        path: '/'
      });
      return string;
    } catch (error) {
      return '';
    }
  }, [authCookies, localStorageKeys]);

  /**
   * Handler function to save authentication result.
   *
   * @param {AuthResult} authResult - The authentication data object.
   */
  const saveAuthResult = _react.default.useCallback(_ref2 => {
    let {
      authResult,
      callback = () => {}
    } = _ref2;
    const expiresAt = parseInt(((0, _moment.default)() + _moment.default.unix(authResult.expiresIn).utc()) / 1000, 10);
    window.localStorage.setItem(localStorageKeys.accessToken, authResult.accessToken);
    window.localStorage.setItem(localStorageKeys.expiresAt, expiresAt);
    _jsCookie.default.set(authCookies.accessToken, authResult.accessToken, {
      path: '/'
    });
    _jsCookie.default.set(authCookies.expiresAt, expiresAt, {
      path: '/'
    });
    if (callback && typeof callback === 'function') {
      callback();
    }
  }, [authCookies, localStorageKeys]);

  /**
   * Fetch and set user profile via Auth0 Web Auth client.
   *
   * @param {AuthResult} authResult - Optional AuthResult object used to fetch the profile (Default: null).
   *
   * @returns {Function} Log or setUser function invocation, depending on user profile existence and status.
   *
   * @see For more information: {@link https://auth0.com/docs/libraries/auth0js#extract-the-authresult-and-get-user-info}.
   */
  const fetchProfile = _react.default.useCallback(function () {
    let {
      authResult = null,
      callback = () => {}
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (webAuth) {
      const userProfile = JSON.parse(window.localStorage.getItem(localStorageKeys.userProfile));
      if (userProfile) {
        window.localStorage.setItem(localStorageKeys.userProfile, JSON.stringify(userProfile));
        setUser(userProfile);
        setIsAuthenticated(true);
        setIsOrganization(checkOrganizationProfile(userProfile));
        setIsUserChecked(true);
        if (callback && typeof callback === 'function') {
          callback();
        }
      }
      if (!userProfile && !user) {
        const authAccessToken = authResult && authResult.accessToken || _jsCookie.default.get(authCookies.accessToken);
        if (!authAccessToken) {
          // Silently fail and trigger callback().
          (0, _errorLogger.logError)(new Error('Access token must exist to fetch profile.'));
          if (callback && typeof callback === 'function') {
            callback();
          }
        } else {
          setStatus(_constants.STATUS_TYPES.PENDING);
          webAuth.client.userInfo(authAccessToken, (err, profile) => {
            setStatus(_constants.STATUS_TYPES.IDLE);
            if (profile) {
              window.localStorage.setItem(localStorageKeys.userProfile, JSON.stringify(profile));
              setUser(profile);
              setIsAuthenticated(true);
              setIsOrganization(checkOrganizationProfile(profile));
              setIsUserChecked(true);
              if (callback && typeof callback === 'function') {
                callback({
                  userProfile: profile
                });
              }
            } else if (err) {
              // Silently fail and trigger callback().
              (0, _errorLogger.logError)(err.original);
              if (callback && typeof callback === 'function') {
                callback();
              }
            } else if (callback && typeof callback === 'function') {
              (0, _errorLogger.logError)(new Error('webAuth.client.userInfo: No error or profile object.'));
              callback();
            }
          });
        }
      }
    }
  }, [authCookies, checkOrganizationProfile, localStorageKeys, user, webAuth]); // NOSONAR

  /**
   * Handler function for authentication callback. This includes ensuring the
   * presence of required values in window.location.hash before parsing and
   * continuing authentication.
   *
   * @param {object} params - The function params object.
   * @param {string} [params.path] - Optional path to add to redirect URL (Default: '').
   *
   * @see For more information: {@link https://auth0.com/docs/libraries/auth0js#extract-the-authresult-and-get-user-info}.
   */
  const handleAuthentication = _react.default.useCallback(function () {
    let {
      path = ''
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (webAuth) {
      if (/access_token|id_token|error/.test(window.location.hash)) {
        var _getEncodedString;
        setStatus(_constants.STATUS_TYPES.PENDING);
        webAuth.parseHash({
          hash: window.location.hash,
          state: (_getEncodedString = getEncodedString()) !== null && _getEncodedString !== void 0 ? _getEncodedString : _jsCookie.default.get(authCookies.authorizeState)
        }, (err, authResult) => {
          setStatus(_constants.STATUS_TYPES.IDLE);
          if (authResult && authResult.accessToken) {
            saveAuthResult({
              authResult,
              callback: () => {
                fetchProfile({
                  authResult,
                  callback: _ref3 => {
                    let {
                      userProfile
                    } = _ref3;
                    if (userProfile) {
                      (0, _analytics.callSegmentTrack)({
                        event: _constants.AUTH0.events.accountLoggedIn,
                        properties: {
                          logged_in: true,
                          preferred_campus: null,
                          referrer: document && document.referrer ? document.referrer : null,
                          title: document && document.title ? document.title : '',
                          url: window && window.location && window.location.href ? window.location.href : '',
                          user_id: userProfile['https://www.life.church/rock_person_alias_id']
                        }
                      });
                    }
                    redirectToMainApp({
                      path
                    });
                  }
                });
              }
            });
          } else if (err && err.error === 'unauthorized' && err.errorDescription === 'user is blocked') {
            (0, _analytics.callSegmentTrack)({
              event: _constants.AUTH0.events.accountLoggedInError,
              properties: {
                logged_in: false,
                message: err.errorDescription,
                referrer: document && document.referrer ? document.referrer : null,
                title: document && document.title ? document.title : '',
                url: window && window.location && window.location.href ? window.location.href : '',
                user_id: null
              }
            });
            (0, _errorLogger.logError)(new Error(err.errorDescription), {
              browserConsole: true,
              windowAlert: true
            });
            redirectToMainApp({
              error: authErrors.accountDisabled
            });
          } else if (err) {
            (0, _analytics.callSegmentTrack)({
              event: _constants.AUTH0.events.accountLoggedInError,
              properties: {
                logged_in: false,
                message: err.errorDescription,
                referrer: document && document.referrer ? document.referrer : null,
                title: document && document.title ? document.title : '',
                url: window && window.location && window.location.href ? window.location.href : '',
                user_id: null
              }
            });
            (0, _errorLogger.logError)(new Error(err.errorDescription));
            (0, _errorLogger.logError)(new Error(authErrors.loginError), {
              browserConsole: false,
              windowAlert: true
            });
            redirectToMainApp({
              error: authErrors.loginError
            });
          } else {
            (0, _errorLogger.logError)(new Error('No auth result access token, no error.'));
          }
        });
      }
    }
  }, [authCookies, authErrors, fetchProfile, getEncodedString, redirectToMainApp, saveAuthResult, webAuth]);

  /**
   * Convenience function to check session status for user authentication.
   *
   * @see For more information: {@link https://auth0.com/docs/libraries/auth0js#using-checksession-to-acquire-new-tokens}.
   */
  const checkSession = _react.default.useCallback(function () {
    let {
      callback: _callback = () => {}
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (webAuth) {
      // Note: Not setting any parameters ensures those used with `authorize` are used.
      webAuth.checkSession({}, (err, result) => {
        if (err) {
          setIsAuthenticated(false);
          destroyUserSession();
          if (_callback && typeof _callback === 'function') {
            _callback();
          }
        } else if (result) {
          saveAuthResult({
            authResult: result,
            callback: () => {
              fetchProfile({
                authResult: result,
                callback: _callback
              });
            }
          });
        } else {
          (0, _errorLogger.logError)(new Error('webAuth.checkSession: No error or result object.'));
        }
      });
    }
  }, [destroyUserSession, fetchProfile, saveAuthResult, webAuth]);

  /**
   * Convenience function to check the Login status for a user.
   */
  const checkLogin = _react.default.useCallback(function () {
    var _JSON$parse;
    let {
      suppressAnalytics
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      suppressAnalytics: false
    };
    const userProfile = (_JSON$parse = JSON.parse(window.localStorage.getItem(localStorageKeys.userProfile))) !== null && _JSON$parse !== void 0 ? _JSON$parse : user;

    /**
     * Authentication check and value setting.
     *
     * Note: Explicitly setting state separate from function check of auth
     * status to ensure no delay or lapse in state within this file.
     */
    if (!checkAuthenticationStatus()) {
      setIsAuthenticated(false);
      destroyUserSession();
      checkSession();
      setIsUserChecked(true);
    } else if (userProfile) {
      setUser(userProfile);
      setIsAuthenticated(true);
      setIsOrganization(checkOrganizationProfile(userProfile));
      setIsUserChecked(true);

      // Segment identify trigger.
      const segmentUser = {};
      const userAnalyticsKeys = ['family_name', 'given_name', 'https://www.life.church/rock_person_alias_id', 'locale', 'nickname', 'sub'];
      userAnalyticsKeys.forEach(key => {
        if (userProfile[key]) {
          let userKey = null;
          switch (key) {
            case 'family_name':
              userKey = 'last_name';
              break;
            case 'given_name':
              userKey = 'first_name';
              break;
            case 'https://www.life.church/rock_person_alias_id':
              userKey = 'userId';
              break;
            case 'locale':
              userKey = 'language';
              break;
            case 'nickname':
              userKey = 'webnickname';
              break;
            case 'sub':
              userKey = 'auth0_id';
              break;
            default:
              break;
          }
          segmentUser[userKey] = userProfile[key];
        }
      });
      if (window && window.analytics && window.analytics.identify && userProfile['https://www.life.church/rock_person_alias_id'] && !suppressAnalytics) {
        /* istanbul ignore next */
        (0, _analytics.callSegmentIdentify)({
          traits: segmentUser,
          userId: userProfile['https://www.life.church/rock_person_alias_id']
        });
      }
    } else {
      (0, _errorLogger.logError)(new Error('checkLogin: No userProfile found, but valid authenticationStatus() retrieved.'));
    }
  }, [localStorageKeys, checkAuthenticationStatus, checkOrganizationProfile, checkSession, destroyUserSession, user]);

  /**
   * Convenience function to retrieve and return authentication access token.
   */
  const getAccessToken = _react.default.useCallback(() => {
    var _Cookies$get;
    const storedAccessToken = (_Cookies$get = _jsCookie.default.get(authCookies.accessToken)) !== null && _Cookies$get !== void 0 ? _Cookies$get : window.localStorage.getItem(localStorageKeys.accessToken);
    return storedAccessToken;
  }, [authCookies.accessToken, localStorageKeys]);

  /**
   * Convenience function to build authentication URL and open in new window.
   *
   * @param {object} params - The function params object.
   * @param {string} [params.hash] - Optional hash string to apply to the end of the authorize url that triggers Auth0 login.
   * @param {string} [params.redirectUri] - The redirectUri to use for callback after authentication. (Default: redirectUri value from Web Auth configuration).
   *
   * @see For more information: {@link https://auth0.com/docs/libraries/auth0js#buildauthorizeurl-options-}.
   */
  const logIn = _react.default.useCallback(function () {
    let {
      callback = null,
      hash = '',
      isOverride,
      redirectUri,
      returnTo = null
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      callback: null,
      hash: '',
      isOverride: false,
      redirectUri: null,
      returnTo: null
    };
    // Store returnTo in localStorage.
    if (returnTo) {
      window.localStorage.setItem('return_to', returnTo);
    } else {
      // Store current location as default.
      const currentLocation = "".concat(window.location.pathname).concat(window.location.search);
      window.localStorage.setItem('return_to', currentLocation);
    }
    const encodedString = setEncodedString();
    let finalHash = hash && typeof hash === 'string' ? hash.replace('#', '') : '';
    if (finalHash) {
      finalHash = "#".concat(finalHash);
    }
    let counter = 0;
    setTimeout(() => {
      // eslint-disable-next-line consistent-return
      const interval = setInterval(() => {
        if (isConfigured && webAuth && webAuth.client) {
          clearInterval(interval);
          const url = webAuth.client.buildAuthorizeUrl({
            clientID: webAuthConfig.clientID,
            nonce: encodedString,
            redirectUri: redirectUri || webAuthConfig.redirectUri,
            state: encodedString
          });
          /**
           * Get the Segment anonymous id value, if found, and send along as a
           * query parameter to the auth URL. This helps to ensure the user
           * session persists via the anonymous id value (seen in the raw
           * data in Segment) to be able to track the user through the entire
           * authentication flow, even across domains.
           *
           * @see For more information: {@link: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/querystring/}.
           */
          const aId = window && window.analytics && window.analytics.user ? "&ajs_aid=".concat(window.analytics.user().anonymousId()) : null;
          if (isOverride && callback && typeof callback === 'function') {
            callback({
              url: "".concat(url).concat(aId).concat(finalHash)
            });
          } else {
            window.open("".concat(url).concat(aId).concat(finalHash), '_self');
          }
        } else if (counter > 10) {
          clearInterval(interval);
        } else {
          counter += 1;
        }
      }, 250);
    }, 100);
  }, [isConfigured, setEncodedString, webAuth, webAuthConfig]);

  /**
   * Convenience function to log out user by removing data and triggering logout
   * on auth0 object.
   *
   * @param {string} returnTo - URL to which to return the user after log out is complete.
   *
   * @see For more information: {@link https://auth0.com/docs/libraries/auth0js#logout}.
   */
  const logOut = _react.default.useCallback(returnTo => {
    const userProfile = JSON.parse(window.localStorage.getItem(localStorageKeys.userProfile));
    (0, _analytics.callSegmentTrack)({
      event: _constants.AUTH0.events.accountLoggedOut,
      properties: {
        logged_in: false,
        preferred_campus: null,
        referrer: document && document.referrer ? document.referrer : null,
        title: document && document.title ? document.title : '',
        url: window && window.location && window.location.href ? window.location.href : '',
        user_id: userProfile ? userProfile['https://www.life.church/rock_person_alias_id'] : null
      }
    });
    destroyUserSession();
    webAuth.logout({
      clientID: webAuthConfig.clientID,
      returnTo
    });
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [destroyUserSession, webAuth, webAuthConfig]);

  /**
   * Single-run convenience effect to fetch data and set up Auth0 Web Auth.
   *
   * @see For more information: {@link https://auth0.com/docs/libraries/auth0js#initialization}.
   */
  _react.default.useEffect(() => {
    if (webAuth && !isInitialLoginChecked) {
      setIsInitialLoginChecked(true);
      checkLogin({
        suppressAnalytics: true
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialLoginChecked, webAuth]);
  const value = _react.default.useMemo(() => ({
    checkLogin,
    checkSession,
    configure,
    getAccessToken,
    handleAuthentication,
    isAuthenticated,
    isConfigured,
    isError,
    isIdle,
    isLoading,
    isOrganization,
    isSuccess,
    isUserChecked,
    logIn,
    logOut,
    user
  }), [checkLogin, checkSession, configure, getAccessToken, handleAuthentication, isAuthenticated, isConfigured, isError, isIdle, isLoading, isOrganization, isSuccess, isUserChecked, logIn, logOut, user]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    _react.default.createElement(AuthContext.Provider, _extends({
      value: value
    }, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 825,
        columnNumber: 5
      }
    }), children)
  );
}
AuthProvider.propTypes = {
  /**
   * The React children.
   */
  children: _propTypes.default.node
};